import createRelayEntryPoint from 'consumer-mobile-web/utils/createRelayEntryPoint'

createRelayEntryPoint({
  screenImport: () => import('consumer-mobile-web/screens/DirectMobileWeb'),
})
